export const ZOOM_VALUE_DISPLAY_OFFSET = 40;
export const ZOOM_RANGE = {
  min: 0.8,
  max: 2,
  precision: 1,
  increment: 0.2,
  decrement: 0.2,
};
export const ZOOM_INITIAL_VALUE = 1.2;
export const buttonIconSize = 14;
export const bevLabels = {
  pageHeading: 'Select the unit of your choice',
  dropDownLabel: 'Select the floor',
  buttons: {
    autoAllocate: 'Auto-Allocate Unit',
    exit: 'Exit',
  },
  modal: {
    mainTitle: 'Selected Unit Details',
    unitTypeLabels: 'Unit Type',
    unitNumberLabel: 'Unit Number',
    exitBtnLabel: 'Exit',
    rentBtnLabel: 'Rent Unit',
  },
  notAvailable: {
    overlay: 'No unit of selected unit type is available on the floor.',
    heading: 'No unit of selected unit type is available on the floor.',
  },
};
export const CANVAS_DIMENSIONS = {
  viewModeDimensions: {
    width: 16 * 150,
    height: 9 * 150,
  },
};
